import { CityFeature } from "@/schemas/city-schema";
import { imageFilesType } from "@/schemas/imagery-schema";
import {
	IMergedObservationAndStation,
	observationsType,
} from "@/schemas/observation-schema";

export const mergeObservationDataWithStation = ({
	kuwaitStation,
	observationData,
	firstDate,
}: {
	firstDate: Date;
	kuwaitStation: CityFeature[];
	observationData: observationsType[];
}): IMergedObservationAndStation[][] => {
	const merged = observationData.map((obsItemArray, idx) => {
		const observationDate = new Date(firstDate);

		observationDate.setHours(observationDate.getHours() + idx);

		if (obsItemArray.length === 0) {
			return kuwaitStation.map((station) => ({
				priority: station.properties.Priority,
				stationId: station.properties.id,
				coordinates: station.geometry.coordinates,
				data: {
					present_weather: undefined,
					temperature: undefined,
					precipitation_1h: undefined,
					precipitation_3h: undefined,
					wind_direction: undefined,
					wind_speed: undefined,
					relative_humidity: undefined,
					visibility: undefined,
					feel_like: undefined,
					date: observationDate,
				},
			}));
		}

		return obsItemArray.map((obsData) => {
			const findItem = kuwaitStation.find(
				(item) => item.properties.id === obsData.station_id,
			);

			if (!findItem) {
				return {
					...obsData,
					priority: undefined,
					data: {
						date: observationDate,
					},
				};
			}

			return {
				...obsData,
				priority: findItem.properties.Priority,
				coordinates: findItem.geometry.coordinates,
			};
		});
	});

	return merged;
};

export const getFirstObsDateAndLast = (
	observations: IMergedObservationAndStation[][],
): {
	firstDate: Date;
	lastDate: Date;
} => {
	const observationLength = observations.length;

	if (observationLength === 0)
		return {
			firstDate: new Date(),
			lastDate: new Date(),
		};

	const firstDate = observations[0]?.[0]?.data?.date ?? new Date();
	const lastDate =
		observations[observationLength - 1]?.[0]?.data?.date ?? new Date();

	return {
		firstDate,
		lastDate,
	};
};

export const fillMissingImagery = ({
	imagery,
	observations,
}: {
	imagery: imageFilesType[];
	observations: IMergedObservationAndStation[][];
}): imageFilesType[] => {
	let lastFilename = imagery[0]?.filename ?? "";

	return observations.map((obs) => {
		const currentDate = obs?.[0]?.data?.date;

		if (!currentDate) {
			return {
				filename: lastFilename,
				date: new Date(),
			};
		}

		const image = imagery.find(
			(item) => item.date.getHours() === currentDate.getHours(),
		);

		if (image) {
			lastFilename = image.filename;

			return {
				...image,
				date: currentDate,
			};
		}

		return {
			filename: lastFilename,
			date: currentDate,
		};
	});
};
